import React from "react";
import {
  StyleSheet,
  Modal,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import BottomButton from "./BottomButton";

const ConfirmationModal = ({
  showConfirmationModal,
  setShowConfirmationModal,
  customerCount = 0,
  onPressConfirm = () => {},
}) => (
  <Modal
    animationType="fade"
    transparent={true}
    visible={showConfirmationModal}
    onRequestClose={() => {
      setShowConfirmationModal(!showConfirmationModal);
    }}
  >
    <TouchableWithoutFeedback onPress={() => setShowConfirmationModal(false)}>
      <View style={styles.modalOverlay} />
    </TouchableWithoutFeedback>
    <View style={styles.modalContainer}>
      <View style={styles.content}>
        {customerCount > 0 ? (
          <Text
            variant="body_text_3"
            style={{
              color: color.mediumBlack,
              padding: 12,
              marginBottom: 8,
              textAlign: "center",
            }}
          >
            {`Are you sure you wish to continue marking "out for delivery" `}
            <Text variant="body_text_2" style={{ color: color.mediumBlack }}>
              {`without ${customerCount} customer ?`}
            </Text>
          </Text>
        ) : null}
        <BottomButton
          onPress={onPressConfirm}
          title="Confirm"
          showBottomContainer={false}
        />
      </View>
    </View>
  </Modal>
);

export default ConfirmationModal;

const styles = StyleSheet.create({
  modalOverlay: {
    backgroundColor: "rgba(0,0,0, 0.4)",
    flex: 1,
  },

  modalContainer: {
    width: "90%",
    margin: 20,
    backgroundColor: "white",
    borderRadius: 8,
    padding: 12,
    paddingHorizontal: 20,
    alignItems: "center",
    alignContent: "center",
    position: "absolute",
    top: "35%",
  },
  content: {
    width: "100%",
    alignItems: "center",
  },
});
